module.exports = __webpack_public_path__ + "img/amor-face-3.708977ca.jpg";